import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem("customerIsAuthenticated") === 'true';

  if (!isAuthenticated) {
    // If the user is not authenticated, redirect them to the login page.
    return <Navigate to="/" replace />;
  }

  // If the user is authenticated, render the component they were trying to access.
  return children;
};

export default ProtectedRoute;